function gerarPdf(
  nome,
  dataInicial,
  dataFinal,
  metadadosAtendimentos,
  atendimentosNaoEncerradosPrimeiroContato,
  atendimentosAbertosPorTerceirosEncerradosPorMim
) {
  return `
    <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Relatório</title>
    ${_obterCSS()}
</head>
<body>
    <h2 class="titulo">Relatório gerado no período de ${dataInicial || ""} a ${
    dataFinal || ""
  } para ${nome || ""}</h2>
    <hr>
    <table class="numeros-graficos">
        <tr>
          <th colspan="2" scope="colgroup">Atendimentos abertos</th>
          <th colspan="3" scope="colgroup">Atendimentos resolvidos</th>
        </tr>
        <tr>
            <th>Novos</th>
            <th>Outros</th>
            <th>Resolvidos de terceiros</th>
            <th>Primeiro contato</th>
            <th>Outros</th>
        </tr>
    ${_montarMetaDadosAtendimentos(metadadosAtendimentos)}
    </table>
    <h2 class="titulo">Atendimentos não encerrados no primeiro contato e abertos por ${
      nome || ""
    }</h2>
    <table>
        <tr>
            <th>Atendimento</th>
            <th>Dias em aberto</th>
            <th>Usuário abertura</th>
        </tr>
        ${_montarAtendimentosNaoEncerradosPrimeiroContato(
          atendimentosNaoEncerradosPrimeiroContato
        )}
    </table>
    <h2 class="titulo">Atendimentos abertos por outros usuários e encerrados por ${
      nome || ""
    }</h2>
    <table>
        <tr>
            <th>Atendimento</th>
            <th>Usuário abertura</th>
            <th>Usuário encerramento</th>
        </tr>
        ${_montarAtendimentosAbertosDeTerceirosEncerradosPeloUsuarioLogado(
          atendimentosAbertosPorTerceirosEncerradosPorMim
        )}
    </table>
</body>
</html>`;
}

function _montarMetaDadosAtendimentos(metadadosAtendimentos) {
  metadadosAtendimentos =
    (Array.isArray(metadadosAtendimentos) && metadadosAtendimentos) || [];

  let novos = metadadosAtendimentos.reduce(
    (acc, elemento) => acc + elemento.totalAbertosNovos,
    0
  );

  let outrosAbertos = metadadosAtendimentos.reduce(
    (acc, elemento) =>
      acc + (elemento.totalAbertos - elemento.totalAbertosNovos),
    0
  );

  let resolvidosTerceiros = metadadosAtendimentos.reduce(
    (acc, elemento) => acc + elemento.totalResolvidosDeTerceiros,
    0
  );

  let resolvidosPrimeiroContato = metadadosAtendimentos.reduce(
    (acc, elemento) => acc + elemento.totalResolvidosNoPrimeiroContato,
    0
  );

  let outrosResolvidos = metadadosAtendimentos.reduce(
    (acc, elemento) =>
      acc +
      (elemento.totalResolvidos -
        elemento.totalResolvidosNoPrimeiroContato -
        elemento.totalResolvidosDeTerceiros),
    0
  );

  return `
    <tr>
        <td>${novos}</td>
        <td>${outrosAbertos}</td>
        <td>${resolvidosTerceiros}</td>
        <td>${resolvidosPrimeiroContato}</td>
        <td>${outrosResolvidos}</td>
    </tr>
        `;
}

function _montarAtendimentosNaoEncerradosPrimeiroContato(
  atendimentosNaoEncerradosPrimeiroContato
) {
  atendimentosNaoEncerradosPrimeiroContato =
    (Array.isArray(atendimentosNaoEncerradosPrimeiroContato) &&
      atendimentosNaoEncerradosPrimeiroContato) ||
    [];
  let html = "";

  for (let i = 0; i < atendimentosNaoEncerradosPrimeiroContato.length; i++) {
    html += `
      <tr>
        <td>${atendimentosNaoEncerradosPrimeiroContato[i].codigoChamada}</td>
        <td>${atendimentosNaoEncerradosPrimeiroContato[i].diasEmAberto}</td>
        <td>${atendimentosNaoEncerradosPrimeiroContato[i].loginUsuario}</td>
      </tr> 
      `;
  }

  return html;
}

function _montarAtendimentosAbertosDeTerceirosEncerradosPeloUsuarioLogado(
  atendimentosAbertosPorTerceirosEncerradosPorMim
) {
  atendimentosAbertosPorTerceirosEncerradosPorMim =
    (Array.isArray(atendimentosAbertosPorTerceirosEncerradosPorMim) &&
      atendimentosAbertosPorTerceirosEncerradosPorMim) ||
    [];

  let html = "";

  for (
    let i = 0;
    i < atendimentosAbertosPorTerceirosEncerradosPorMim.length;
    i++
  ) {
    html += `
      <tr>
        <td>${atendimentosAbertosPorTerceirosEncerradosPorMim[i].codigoChamada}</td>
        <td>${atendimentosAbertosPorTerceirosEncerradosPorMim[i].loginUsuarioAbertura}</td>
        <td>${atendimentosAbertosPorTerceirosEncerradosPorMim[i].loginUsuarioEncerramento}</td>
        </tr>
      `;
  }

  return html;
}

function _obterCSS() {
  return `
    <style>
    body {
        padding-inline: 30px;
        font-size: 25px;
    }
    
    table {
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
      margin-bottom: 50px;
    }

    
    td,
    th {
      border: 1px solid #dddddd;
      text-align: center;
      padding: 8px;
      font-size: 16px;
    }
    
    td {
        color: #90989f;
    }
    
    h2 {
        font-size: 16px;
        font-weight: 300;
        color: #90989f;
    }
    
    hr {
        border: 0.1px solid #dadada;
    }
    
    .titulo {
        text-align: left;
        font-family: Arial, Helvetica, sans-serif;
    }
    
    .numeros-graficos {
        margin-top: 25px;
    }
    
    </style>`;
}

export default {
  gerarPdf,
};
